import { render, staticRenderFns } from "./AdminEntityItemDetail.vue?vue&type=template&id=2272f8e6&scoped=true"
import script from "./AdminEntityItemDetail.vue?vue&type=script&lang=js"
export * from "./AdminEntityItemDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminEntityItemDetail.vue?vue&type=style&index=0&id=2272f8e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2272f8e6",
  null
  
)

export default component.exports